import React from 'react';
import { Link } from 'react-router-dom';
import { LogoUpim } from '../ui-upim';
import './affiliation.css';

export default function AffiliationShell({ step, title, description, children }) {
  return <main className="affiliation-flow"><div className="af-wrap">
    <Link to="/" aria-label="Inicio UPIM" className="af-logo"><LogoUpim className="h-12" claseTexto="text-2xl" /></Link>
    <div className="af-heading"><p className="af-eyebrow">UPIM · Red profesional de negocios inmobiliarios</p>
      {step && <p className="af-step">{step}</p>}<h1>{title}</h1><p>{description}</p></div>
    {children}
    <footer className="af-foot"><Link to="/terminos">Términos</Link><Link to="/aviso-privacidad">Privacidad</Link><Link to="/contacto">Ayuda UPIM</Link></footer>
  </div></main>;
}
